import {
  BelayUserConnection,
  RequestState,
  UserConnection,
  UserConnectionActions,
  UserConnectionActionType,
  UserConnectionLink,
  UserConnectionLinkRel
} from '@alltrails/types/belay';

const linkRelToActionType: Record<UserConnectionLinkRel, UserConnectionActionType> = {
  [UserConnectionLinkRel.Accept]: UserConnectionActionType.Accept,
  [UserConnectionLinkRel.Deny]: UserConnectionActionType.Deny,
  [UserConnectionLinkRel.Block]: UserConnectionActionType.Block,
  [UserConnectionLinkRel.RequestFollow]: UserConnectionActionType.Follow,
  [UserConnectionLinkRel.RequestFollowBack]: UserConnectionActionType.FollowBack,
  [UserConnectionLinkRel.Dismiss]: UserConnectionActionType.Dismiss,
  [UserConnectionLinkRel.RetractRequest]: UserConnectionActionType.RetractRequest,
  [UserConnectionLinkRel.Unfollow]: UserConnectionActionType.Unfollow,
  [UserConnectionLinkRel.Unblock]: UserConnectionActionType.Unblock,
  [UserConnectionLinkRel.RemoveFollower]: UserConnectionActionType.RemoveFollower
};

const mapBelayLinksToActions = (links: UserConnectionLink[]): UserConnectionActions =>
  links.reduce((actions, link) => {
    const { href, method, rel } = link;
    // Protect against belay adding a new link type before the client supports it
    if (Object.keys(linkRelToActionType).includes(rel)) {
      const actionKey = linkRelToActionType[rel];
      return {
        ...actions,
        [actionKey]: { href, method, title: link.title, requestState: RequestState.Idle }
      };
    }
    return actions;
  }, {} as UserConnectionActions);

const addActionsToUserConnection = ({ links, ...userConnection }: BelayUserConnection): UserConnection => ({
  ...userConnection,
  actions: mapBelayLinksToActions(links)
});

export default addActionsToUserConnection;
